import React, { Component } from 'react'
import { processSilentRenew } from 'redux-oidc'

export class SilentRedirectPage extends Component {
  componentDidMount() {
    processSilentRenew()
  }

  render() {
    return <div></div>
  }
}
